/* src/modules/interviews/api.js */

import gql from 'graphql-tag';
import { APPLICANT_FRAGMENT } from '../tutors/api';

const INTERVIEW_SCHEDULE_FRAGMENT = gql`
  fragment InterviewScheduleFragment on InterviewSchedule {
    startTime {
      timestamp
    }
  }
`;

const INTERVIEW_FRAGMENT = gql`
  fragment InterviewFragment on Interview {
    _id
    status
    tutor {
      _id
      user {
        _id
        first
        last
      }
    }
    location {
      _id
      name
      type
    }
    current {
      ...InterviewScheduleFragment
    }
    request {
      ...InterviewScheduleFragment
    }
    timeline {
      type
      emitter
      date {
        timestamp
      }
    }
  }
  ${INTERVIEW_SCHEDULE_FRAGMENT}
`;

export const FETCH_INTERVIEWS_QUERY = gql`
  {
    interviews(statuses: [PENDING, R_PENDING, CONFIRMED]) {
      ...InterviewFragment
    }
  }
  ${INTERVIEW_FRAGMENT}
`;

export const CONFIRM_INTERVIEW_MUTATION = gql`
  mutation confirmInterview($interview: ID!) {
    confirmInterview(_interview: $interview) {
      ...InterviewFragment
    }
  }
  ${INTERVIEW_FRAGMENT}
`;

export const DECLINE_INTERVIEW_MUTATION = gql`
  mutation declineInteview($interview: ID!, $reason: String!) {
    declineInterview(_interview: $interview, reason: $reason) {
      ...InterviewFragment
    }
  }
  ${INTERVIEW_FRAGMENT}
`;

export const ADD_SCHEDULE_MUTATION = gql`
  mutation addAdminSchedule($input: ScheduleInput!) {
    addAdminSchedule(input: $input) {
      _id
    }
  }
`;

export const UPDATE_TIMEBLOCK_MUTATION = gql`
  mutation updateTimeblock($input: TimeblockUpdateInput!) {
    updateTimeblock(input: $input) {
      _id
    }
  }
`;

export const REMOVE_TIMEBLOCK_MUTATION = gql`
  mutation removeTimeblock($timeblock: ID!) {
    removeTimeblock(_timeblock: $timeblock) {
      _id
    }
  }
`;

export const UPDATE_SCHEDULE_MUTATION = gql`
  mutation updateSchedule($input: TimeblockUpdateInput!) {
    updateSchedule(input: $input) {
      _id
    }
  }
`;

export const REMOVE_SCHEDULE_MUTATION = gql`
  mutation removeSchedule($timeblock: ID!) {
    removeSchedule(_timeblock: $timeblock) {
      _id
    }
  }
`;


export const FETCH_SCHEDULE_QUERY = gql`
  query getSchedule($universities: [ID!]) {
    adminSchedules(universities: $universities) {
      user {
        _id
        first
        last
      }
      timeblocks {
        _id
        pattern
        date {
          timestamp
        }
        startTime {
          timestamp
        }
        endTime {
          timestamp
        }
      }
    }
  }
`;

export const FETCH_INTERVIEW_LOCATIONS_QUERY = gql`
  query getInterviewLocations($universities: [ID]!) {
    fetchInterviewLocations(universities: $universities) {
      _id
      name
      address
      coordinates {
        longitude
        latitude
      }
      city
    }
  }
`;

const QUESTION_FRAGMENT = gql`
  fragment QuestionFragment on Question {
    _id
    text
  }
`;

export const FETCH_INTERVIEW_QUESTIONS_QUERY = gql`
  {
    questions {
      ...QuestionFragment
    }
  }
  ${QUESTION_FRAGMENT}
`;

export const ADD_INTERVIEW_QUESTION_MUTATION = gql`
  mutation addQuestion($input: QuestionInput!) {
    addQuestion(input: $input) {
      ...QuestionFragment
    }
  }
  ${QUESTION_FRAGMENT}
`;

export const UPDATE_INTERVIEW_QUESTION_MUTATION = gql`
  mutation updateQuestion($question: ID!, $text: String!) {
    updateQuestion(_question: $question, text: $text) {
      ...QuestionFragment
    }
  }
  ${QUESTION_FRAGMENT}
`;

export const REMOVE_INTERVIEW_QUESTION_MUTATION = gql`
  mutation removeQuestion($question: ID!) {
    removeQuestion(_question: $question)
  }
`;

export const SAVE_ANSWERS_AND_RATINGNS_MUTATION = gql`
  mutation saveAnswersAndRatings($applicant: ID!, $input: [QAndAInput!]!, $ratings: ApplicantRatingsInput!) {
    updateQuestionsAndRatings(_applicant: $applicant, input: $input, ratings: $ratings) {
      ...ApplicantFragment
    }
  }
  ${APPLICANT_FRAGMENT}
`;

export const UPDATE_APPLICANT_STATUS_MUTATION = gql`
  mutation updateApplicantStatus($applicant: ID!, $status: ApplicantStatus!, $reason: String) {
    updateApplicantStatus(_applicant: $applicant, status: $status, reason: $reason) {
      ...ApplicantFragment
    }
  }
  ${APPLICANT_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./src/modules/interviews/api.js